import { VStack } from '@chakra-ui/layout'
import { Box, Divider, Text as ChakraText } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AiOutlineFileText } from 'react-icons/ai'
import { RiUserSettingsLine } from 'react-icons/ri'
import { createGlobalStyle } from 'styled-components'
import { colors } from '../../../ui-kit'
import { SideBar } from '../../layouts/Base'
import { SideBarItem } from '../../layouts/Base/SideBar'

const ActiveLinkStyles = createGlobalStyle`
  .active-link {  
   svg {
        fill: ${colors.appSlate};
      }
    
    p {
      color: ${colors.appSlate};
    }
  }
`

const SupportSideMenu = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <SideBar heading={t('support')}>
      <ActiveLinkStyles />
      <VStack
        overflow="auto"
        h="100%"
        spacing="1em"
        padding="1.5em 0.75em 1.5em"
      >
        <SideBarItem to="/support/documentation" activeClassName="active-link">
          <Box margin="1rem">
            <AiOutlineFileText
              fontSize="2rem"
              fill={colors.appBattleshipGrey}
            />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color={colors.appBattleshipGrey}
            lineHeight="4rem"
          >
            {t('documentation')}
          </ChakraText>
        </SideBarItem>
        <Divider />
        <SideBarItem
          to="/support/useful-resources"
          activeClassName="active-link"
        >
          <Box margin="1rem">
            <RiUserSettingsLine
              fontSize="2rem"
              fill={colors.appBattleshipGrey}
            />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color={colors.appBattleshipGrey}
            lineHeight="4rem"
          >
            {t('useful_resources')}
          </ChakraText>
        </SideBarItem>
        <Divider />
      </VStack>
    </SideBar>
  )
}

export default SupportSideMenu
